// UM Competencies with their URLs
export const UM_COMPETENCIES = {
  1: {
    name: "Strategic Alignment & Roadmapping",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Strategic+Alignment+%26+Roadmapping"
  },
  2: {
    name: "Portfolio Governance & Investment Decisioning",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Portfolio+Governance+%26+Investment+Decisioning"
  },
  3: {
    name: "Risk Intelligence & Adaptive Planning",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Risk+Intelligence+%26+Adaptive+Planning"
  },
  4: {
    name: "Programme Delivery & Integration",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Programme+Delivery+%26+Integration"
  },
  5: {
    name: "Operational Excellence & Performance Management",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Operational+Excellence+%26+Performance+Management"
  },
  6: {
    name: "Change Implementation & Capability Build",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Change+Implementation+%26+Capability+Build"
  },
  7: {
    name: "Stakeholder Engagement & Influence",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Stakeholder+Engagement+%26+Influence"
  },
  8: {
    name: "Leadership & Team Dynamics",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Leadership+%26+Team+Dynamics"
  },
  9: {
    name: "Culture & Communication",
    url: "https://wiki.daringfutures.com/About+us/Uncertainty+Management/Methodology/Model/Culture+%26+Communication"
  }
};

// Mapping of dependency IDs to UM Competency IDs
export const DEPENDENCY_TO_COMPETENCIES = {
  1: [1, 2, 3],
  2: [1, 2, 4],
  3: [3],
  4: [4, 5],
  5: [5],
  6: [4, 6],
  7: [7, 8],
  8: [8, 9],
  9: [7, 8, 9],
  10: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  11: [1, 3, 4],
  12: [8, 9],
  13: [2, 4, 5, 7],
  14: [4, 6, 8]
};

// Helper function to get competencies for a dependency
export const getCompetenciesForDependency = (dependencyId) => {
  const competencyIds = DEPENDENCY_TO_COMPETENCIES[dependencyId] || [];
  return competencyIds.map(id => UM_COMPETENCIES[id]);
};